import {
    ReactElement,
    useRef,
} from 'react';

import {Stack,} from '@mantine/core';

import {useCodeRepositoryList} from '../hooks/useCodeRepositoryList.ts';
import {useCodeRepositoriesFilter} from '../hooks/useCodeRepositoriesFilter.ts';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';
import {useCodeRepositoriesSearch} from "../hooks/useCodeRepositoriesSearch.ts";
import {useCodeRepositoriesSelection} from "../hooks/useCodeRepositoriesSelection.ts";
import {useCodeRepositoriesTableColumns} from "../hooks/useCodeRepositoriesTableColumns.tsx";
import {DataTableColumn} from "mantine-datatable";
import {DataTableTokenPagination} from "../../../../components/DataTableTokenPagination";

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {filters} = useCodeRepositoriesFilter();

    const {
        visibleItems: records,
        loading,
        nextToken,
        fetchNextPage,
    } = useCodeRepositoryList(filters);

    const {
        columns,
    } = useCodeRepositoriesTableColumns();

    const {
        handleFilterByKeyword,
    } = useCodeRepositoriesSearch();

    const {
        selection,
        handleRowSelection,
        handleClearSelection
    } = useCodeRepositoriesSelection();

    const selectedRecords = records.filter(record => selection[record.name]);

    const scrollViewportRef = useRef<HTMLDivElement>(null);

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={10}
                handleItemsPerPageChange={() => {}}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />

            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={(items) => {
                    handleClearSelection();
                    items.forEach((item: any) => {
                        handleRowSelection(item.name, true)
                    })
                }}
                fetching={loading}
                idAccessor={'name'}
                onScrollToBottom={() => fetchNextPage()}
                scrollViewportRef={scrollViewportRef}
            />

            <DataTableTokenPagination
                totalCount={records.length.toString()}
                nextToken={nextToken}
                handleLoadMore={fetchNextPage}
            />
        </Stack>
    );
};
